const map = {
	"./0.png": 49,
	"./1.png": 224,
	"./2.png": 259,
	"./3.png": 906,
	"./4.png": 469,
	"assets/faces/0.png": 49,
	"assets/faces/1.png": 224,
	"assets/faces/2.png": 259,
	"assets/faces/3.png": 906,
	"assets/faces/4.png": 469
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 123;